import React from 'react';
import DeviceCaseSupportedDiagnoseDetailsBattery from './components/DeviceCaseSupportedDiagnoseDetailsBattery';
import DeviceCaseSupportedDiagnoseDetailsMotherboard from "./components/DeviceCaseSupportedDiagnoseDetailsMotherboard";
import DeviceCaseSupportedDiagnoseDetailsKeyboard from "./components/DeviceCaseSupportedDiagnoseDetailsKeyboard";
import DeviceCaseSupportedDiagnoseDetailsLiveCall from "./components/DeviceCaseSupportedDiagnoseDetailsLiveCall";
import DeviceCaseSupportedDiagnoseDetailsBatteryDischarge from "./components/DeviceCaseSupportedDiagnoseDetailsBatteryDischarge";
import DeviceCaseSupportedDiagnoseDetailsDriveHealth from "./components/DeviceCaseSupportedDiagnoseDetailsDriveHealth";

function DeviceCaseSupportedDiagnoseDetails(props) {
    const Key = props.location.state?.redirectOptions?.rowData?.Key;
    switch (Key) {
        case 'motherboard':
            return <DeviceCaseSupportedDiagnoseDetailsMotherboard {...props} />;
        case 'battery_capacity':
            return <DeviceCaseSupportedDiagnoseDetailsBattery {...props} />;
        case 'keyboard':
            return <DeviceCaseSupportedDiagnoseDetailsKeyboard {...props} />;
        case 'livecall':
            return <DeviceCaseSupportedDiagnoseDetailsLiveCall {...props} />;
        case 'battery_discharge':
            return ['mobile', 'headphone'].includes(props.location.state?.redirectOptions?.rowData?.ProductType) ? <DeviceCaseSupportedDiagnoseDetailsBatteryDischarge {...props} /> : null;
        case 'drive_health':
            return <DeviceCaseSupportedDiagnoseDetailsDriveHealth {...props} />;
        default:
            return null;
    }

}

export default DeviceCaseSupportedDiagnoseDetails
